export default "__VITE_ASSET__VIPRlA8y__"